const store = {
    state: {
        credentials: null
    },
    mutations: {
       updateCredentials(state, data) {
           state.credentials = data;
       }
    },
    modules: {}

}

export default store